import React, { useState, useEffect } from "react";
import { Howl, Howler } from "howler";
import { isIOS } from "react-device-detect";

async function queryAudioPlaybackBlocked() {
  return new Promise(async (resolve) => {
    const checkHTML5Audio = async () => {
      const audio = new Audio();
      try {
        audio.play().catch((errors) => { });
        resolve(false);
      } catch (err) {
        resolve(true);
      }
    };
    try {
      const context = new (window.AudioContext || window.webkitAudioContext)();

      await context.resume();
      // context.resume();
      let suspended = context.state === "suspended";
      // if (window.webkitAudioContext) {
      //   console.log("webkit audio context");
      //   suspended = context.state === "suspended";
      // }
      resolve(suspended);
    } catch (e) {
      checkHTML5Audio();
    }
  });
}

async function queryVideoAutoplayBlocked() {
  return new Promise((resolve, reject) => {
    // Create video element to test autoplay
    try {
      const video = document.createElement("video");
      video.autoplay = true;
      video.src =
        "data:video/mp4;base64,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";
      video.load();
      video.style.display = "none";
      video.playing = false;
      video.play().catch(error => {});
      // Check if video plays
      video.onplay = function () {
        this.playing = true;
      };
      // Video has loaded, check autoplay blocked
      video.oncanplay = function () {
        if (video.playing) {
          resolve(false);
        } else {
          resolve(true);
        }
      };
    } catch {
      resolve(true);
    }
  });
}

export default function useAudioContext() {
  const [mute, setMute] = useState(false);
  const [videoMuted, setVideoMuted] = useState(true);
  const [audioPlaybackAllowed, setAudioPlaybackAllowed] = useState(false);
  const [videoPlaybackAllowed, setVideoPlaybackAllowed] = useState(false);
  const [interactedWithVideo, setInteractedWithVideo] = useState(false);
  const [
    canPlayAgentUserNotificationSound,
    setCanPlayAgentUserNotificationSound,
  ] = useState(true);
  const [
    canPlayEventUserNotificationSound,
    setCanPlayEventUserNotificationSound,
  ] = useState(true);
  const [agentUserNotificationSound, setAgentUserNotificationSound] =
    useState(null);
  const [eventUserNotificationSound, setEventUserNotificationSound] =
    useState(null);

  function playAgentUserNotificationSound(
    unreadMessageCount,
    prevUnreadMessageCount
  ) {
    if (
      !mute &&
      agentUserNotificationSound &&
      canPlayAgentUserNotificationSound &&
      !agentUserNotificationSound.playing() &&
      unreadMessageCount > 0 &&
      unreadMessageCount !== prevUnreadMessageCount
    ) {
      agentUserNotificationSound.play();
      setCanPlayAgentUserNotificationSound(false);
    }
  }

  function playEventUserNotificationSound(
    unreadMessageCount,
    prevUnreadMessageCount
  ) {
    if (
      !mute &&
      eventUserNotificationSound &&
      canPlayEventUserNotificationSound &&
      !eventUserNotificationSound.playing() &&
      unreadMessageCount !== prevUnreadMessageCount
    ) {
      eventUserNotificationSound.play();
      setCanPlayEventUserNotificationSound(false);
    }
  }

  function bindUserInteractionListeners() {
    unbindUserInteractionListeners();
    const events = [
      "click",
      "scroll",
      "touchstart",
      "touchend",
      "touchcancel",
      "touchmove",
    ];
    events.forEach((event) => {
      window.addEventListener(event, handleSetAudioPlaybackAllowed);
    });
  }

  function unbindUserInteractionListeners() {
    const events = [
      "click",
      "scroll",
      "touchstart",
      "touchend",
      "touchcancel",
      "touchmove",
    ];
    events.forEach((event) => {
      window.removeEventListener(event, handleSetAudioPlaybackAllowed);
    });
  }

  function handleSetAudioPlaybackAllowed() {
    if (!audioPlaybackAllowed || !videoPlaybackAllowed) {
      queryAutoplayEnabled();
    } else {
      unbindUserInteractionListeners();
    }
  }

  async function queryAutoplayEnabled() {
    if (!isIOS) {
      const videoAutoplayBlocked = await queryVideoAutoplayBlocked();
      setVideoPlaybackAllowed(!videoAutoplayBlocked);
    }

    const audioAutoplayBlocked = await queryAudioPlaybackBlocked();

    setAudioPlaybackAllowed(!audioAutoplayBlocked);
    //setMute(audioAutoplayBlocked);
  }

  useEffect(() => {
    if (audioPlaybackAllowed) {
      setAgentUserNotificationSound(
        new Howl({
          src: ["/assets/sounds/onemotion_message_sound.mp3"],
          volume: 0.2,
        })
      );
      setEventUserNotificationSound(
        new Howl({
          src: ["/assets/sounds/onemotion_message_sound.mp3"],
          volume: 0.2,
        })
      );
    }
  }, [audioPlaybackAllowed]);

  useEffect(() => {
    if (eventUserNotificationSound && agentUserNotificationSound) {
      eventUserNotificationSound.on("end", function () {
        setCanPlayEventUserNotificationSound(true);
      });

      agentUserNotificationSound.on("end", function () {
        setCanPlayAgentUserNotificationSound(true);
      });
    }
  }, [eventUserNotificationSound, agentUserNotificationSound]);

  useEffect(() => {
    if (!audioPlaybackAllowed || !videoPlaybackAllowed) {
      bindUserInteractionListeners();
    }
    return () => {
      unbindUserInteractionListeners();
    };
  }, [audioPlaybackAllowed, videoPlaybackAllowed]);

  function getSoundEnabled() {
    return isSafari
      ? !mute && audioPlaybackAllowed && interactedWithVideo
      : !mute && audioPlaybackAllowed && videoPlaybackAllowed;
  }

  return {
    sounds: {
      playEventUserNotificationSound,
      playAgentUserNotificationSound,
    },
    audioPlaybackAllowed,
    setAudioPlaybackAllowed,
    videoPlaybackAllowed,
    interactedWithVideo,
    setInteractedWithVideo,
    mute,
    setMute,
    getSoundEnabled,
    videoMuted,
    setVideoMuted,
  };
}
